// Ponte entre CRM (consolidar venda) e a tela de Lançar Venda —
// mesma ideia de setPendingEditProposta/takePendingEditProposta.
let _pendingVenda = null
export function setPendingVenda(v) { _pendingVenda = v }
export function takePendingVenda() { var v = _pendingVenda; _pendingVenda = null; return v }
